
export const GET_DASHBOARD_GRAPH = 'GET_DASHBOARD_GRAPH'
export const GET_DASHBOARD_GRAPH_REQUEST = 'GET_DASHBOARD_GRAPH_REQUEST'
export const GET_DASHBOARD_GRAPH_SUCCESS = 'GET_DASHBOARD_GRAPH_SUCCESS'
export const GET_DASHBOARD_GRAPH_FAILURE = 'GET_DASHBOARD_GRAPH_FAILURE'


export const GET_DASHBOARD_TABLE = 'GET_DASHBOARD_TABLE'
export const GET_DASHBOARD_TABLE_REQUEST = 'GET_DASHBOARD_TABLE_REQUEST'
export const GET_DASHBOARD_TABLE_SUCCESS = 'GET_DASHBOARD_TABLE_SUCCESS'
export const GET_DASHBOARD_TABLE_FAILURE = 'GET_DASHBOARD_TABLE_FAILURE'